import React from "react";
import Logo from "./img/logo-glavnoe-white.svg";
import {COOKIES_POLICY_URL, PRIVACY_POLICY_URL, TERMS_OF_USE_URL} from "../constants";


export default function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <div className="footer footer_black footer_nomarg">
            <div className="footer__bottom">
                <div className="footer__inner inner-xs">
                    <div className="footer__topic">
                        <div className="footer__logo">
                            <a href="/" className="logo">
                                <img src={Logo} alt="logo"/>
                            </a>
                        </div>
                        <div className="document-links">
                            <a href={COOKIES_POLICY_URL} target="_blank">Политика обработки файлов cookie</a>
                            <a href={PRIVACY_POLICY_URL} target="_blank">Правила защиты информации</a>
                            <a href={TERMS_OF_USE_URL} target="_blank">О портале</a>
                        </div>
                        <div className="footer__info footer__info_mod">&copy; «glavnoe.life», 2010 - {currentYear}</div>
                    </div>
                    <div className="footer__copy footer__copy_sm text-center">
                        <p>
                            Использование материалов, авторские права на которые принадлежат сторонним ресурсам,
                            возможно только с прямой активной ссылкой на первоисточник.
                        </p>
                        <p>
                            Редакция не несет ответственности за достоверность информации, содержащейся в рекламных
                            объявлениях. Категория интернет-ресурса 18+
                        </p>
                        <p>
                            *упоминаемое в материале (статьях, публикациях, заголовках), размещенном на данном сайте
                            лицо (физическое лицо, юридическое лицо) признано на территории РФ иностранным агентом
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
